import React, { type ReactNode, createContext } from 'react';

import { AuthProvider } from './AuthContext';

// Global app state
type AppContextType = {};

const AppContext = createContext<AppContextType | null>(null);

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <AppContext value={null}>
      <AuthProvider>{children}</AuthProvider>
    </AppContext>
  );
}
